import { createContext, useContext } from 'react'

// Licznik „nowe oferty” Skrzynki ofert (spec §7, §14): jedno źródło danych dla menu i dla ekranu Skrzynki, który woła
// refresh() po akcji użytkownika. Kontekst leży tu, w głównym chunku, a moduł Kontenery jest leniwy — kierunek importu
// to moduł → sidebar, nigdy odwrotnie (R39). Odpytuje ContainersOffersBadgeProvider zamontowany w App.

export interface ContainersOffersBadgeValue {
  /** Oferty „nowe” wg backendu (GET /api/containers/offers/count); 0 bez modułu, bez odpowiedzi i po 403/404. */
  count: number
  /** Odświeża licznik od razu; nic nie robi przy ukrytej karcie, wyłączonym module i po zatrzymaniu przez 403/404. */
  refresh: () => void
}

export const ContainersOffersBadgeContext = createContext<ContainersOffersBadgeValue>({
  count: 0,
  refresh: () => undefined,
})

export const useContainersOffersBadge = (): ContainersOffersBadgeValue => useContext(ContainersOffersBadgeContext)
